/* eslint-disable no-empty */
import { UserType, UserWithTokenType } from "../types";
import { UserConfig } from "./config/user-config";

const Key = "SelfUserWithToken";

export function getSelfUserWithToken(): UserWithTokenType | undefined {
  return UserConfig.get(Key);
}

export function getSelfUser(): UserType | undefined {
  const data = UserConfig.get(Key) as UserWithTokenType | undefined;
  const user = data?.user;
  return user;
}

export function getToken(): string | undefined {
  const data = UserConfig.get(Key) as UserWithTokenType | undefined;
  const token = data?.token;
  return token;
}

export function setSelfUserWithToken(
  selfUserWithToken: UserWithTokenType
): boolean {
  let result = true;
  try {
    UserConfig.set(Key, selfUserWithToken);
  } catch (e) {
    result = false;
  }
  return result;
}

export function removeSelfUserWithToken() {
  UserConfig.delete(Key);
}
